export default __webpack_public_path__ + "static/media/bruno-madruga-modal.e52a8a02.jpg";